define([
  'jquery',
  'underscore',
  'marionette',
  'behaviors/form_errors_behavior',
  'backbone.syphon',
], function ($, _, Marionette, FormErrorsBehavior) {
  return Marionette.View.extend({
    el: '#content_layout',

    behaviors: {
      formErrors: {
        behaviorClass: FormErrorsBehavior,
      },
    },

    ui: {
      /* Roulette */
      spinButton: 'button.spin',
      bronzeButton: 'button.bronze',
      silverButton: 'button.silver',
      goldButton: 'button.gold',
      rouletteType: '.roulette-type',

      /* Dropdown */
      dropdownWrapper: '.dropdown-wrapper',
      dropdownItem: '.dropdown li',
      dropdownAccountItem: '.dropdown.account li',
      dropdownLayerItem: '.dropdown.layer button',

      /* Modal */
      modal: '#ajax_response_modal',
      closeButton: '#ajax_response_modal .close-button',
      confirmButton: '#ajax_response_modal .modal-button',
      dollar: '.dollar',
      rewardHistoryCd: '#reward_history_cd',
      selectedMt4AccountNo: '#selected_mt4_account_no',
      promotionEndModal: '#promotion-end-modal',

      /* Toast */
      toast: '#toast_success',
      toastText: '#toast_text_success',
      toastMessage: '#toast-message',

      /* Tooltip */
      information: 'button.information',
      tooltip: '.bubble',
    },

    events: {
      /* Roulette */
      'click @ui.spinButton': 'handleSpinButtonClick',

      /* Dropdown */
      'click @ui.dropdownWrapper': function (e) {
        this.toggleDropdown(e);
      },
      'click @ui.dropdownItem': function (e) {
        this.selectDropdown(e);
      },
      'click @ui.dropdownLayerItem': function (e) {
        this.changeLayer(e);
      },

      /* Modal */
      'click @ui.closeButton': 'closeModal',
      'click @ui.confirmButton': 'confirmModal',
      'click @ui.dropdownAccountItem':'checkSelectedMt4AccountNo',

      /* Tooltip */
      'click @ui.information': function (e) {
        this.showTooltip(e);
      },
      'click @ui.tooltip': function (e) {
        this.hideTooltip(e);
      },
    },

    initialize: function () {
      this.bindUIElements();

      this.toggleDisableSpinBtn('bronze')

      this.checkWaitReward()

      this.ui.promotionEndModal.modal({ show: true });
    },

    checkWaitReward: function () {
      const that = this;

      $.ajax("/rest_promotion/roulette_promotion_check_wait_reward", {
        method: "GET",

        beforeSend: function () {
          that.ui.spinButton.prop('disabled', true);
          $('.dropdown.layer').closest('.dropdown-wrapper').addClass('disabled');
        },

        success: function (data) {
          if(Object.keys(data).length === 0) {
            that.ui.spinButton.prop('disabled', false);
            $('.dropdown.layer').closest('.dropdown-wrapper').removeClass('disabled');

            return;
          }

          const { rewardHistoryCd, type, amount } = data;

          $('#reward_history_cd').val(rewardHistoryCd);
          that.ui.dollar.html(type + '$' + amount);

          that.openModal()
        },
        error: function (xhr, textStatus, errorThrown) {
          if (xhr.responseJSON.message) {
            that.toast(xhr.responseJSON.message)
            return;
          }
        },
      });
    },

    checkSelectedMt4AccountNo: function () {
      const selected_mt4_account_no = this.ui.selectedMt4AccountNo.data('value');

      if (selected_mt4_account_no) {
        this.ui.confirmButton.prop('disabled', false);
      }
    },

    handleSpinButtonClick: function () {
      const that = this;
      const roulette_type = this.ui.rouletteType.data('value');
      const target_options = {
        "bronze": {
          "credit": {
            3: 3,
            5: 7,
            10: 1,
            20: 5,
          },
          "balance": {
            1: 6,
            3: 2,
            5: 4,
            10: 0,
          }
        },
        "silver": {
          "credit": {
            30: 3,
            50: 7,
            100: 1,
            200: 5,
          },
          "balance": {
            10: 6,
            40: 2,
            80: 4,
            150: 0,
          }
        },
        "gold": {
          "credit": {
            300: 3,
            500: 7,
            1000: 1,
            2000: 5,
          },
          "balance": {
            150: 6,
            500: 2,
            1000: 4,
            2000: 0,
          }
        }
      }

      $.ajax("/rest_promotion/roulette_promotion_spin", {
        method: "POST",
        data: {
          'rouletteType': roulette_type,
        },
        beforeSend: function () {
          that.ui.spinButton.prop('disabled', true);
          $('.dropdown.layer').closest('.dropdown-wrapper').addClass('disabled');
        },
        success: function (data) {
          const { rewardHistoryCd, roulette, type, amount } = data.data;
          const target = target_options[roulette][type][amount];

          $('#reward_history_cd').val(rewardHistoryCd);
          that.ui.dollar.html(type + '$' + amount);
          that.spin(target);
        },
        error: function (xhr, textStatus, errorThrown) {
          if (xhr.responseJSON.message) {
            that.toast(xhr.responseJSON.message)
            return;
          }
        },
      });
    },

    spin: async function (targetSegment) {
      const roulette = document.querySelector('.layer.middle');
      const animations = roulette.getAnimations();

      if (animations.some(({ playState }) => playState === 'running')) return;

      const NUM_SEGMENTS = 8;
      const SEGMENT_ANGLE = 360 / NUM_SEGMENTS;
      const DUMMY_ANGLE = 7 * 360;
      const TARGET_ANGLE = 360 - SEGMENT_ANGLE * targetSegment - SEGMENT_ANGLE / 2;
      const ROTATION_ANGLE = DUMMY_ANGLE + TARGET_ANGLE;
  
      const keyframes = [
        { transform: 'translate(-50%, -50%) rotate(0deg)' },
        { transform: `translate(-50%, -50%) rotate(${ROTATION_ANGLE}deg)` },
      ];
      const options = {
        duration: 5000,
        easing: 'cubic-bezier(0.35, 0.05, 0.2, 1)',
        fill: 'forwards',
        iterations: 1,
      };
  
      await roulette.animate(keyframes, options).finished;

      this.openModal();
    },

    toggleDropdown: function (e) {
      const dropdown = $(e.target).closest('.dropdown-wrapper').find('ul');

      dropdown.toggle();
    },

    selectDropdown: function (e) {
      const label = $(e.target).html();
      const value = $(e.target).data('value');
      const dropdown = $(e.target).closest('ul')
      const selectItem = $(e.target).closest('.dropdown-wrapper').find('.select-item')

      dropdown.hide();
      selectItem.html(label);
      selectItem.data('value', value);

      this.toggleDisableSpinBtn(value)

      e.stopPropagation();
    },

    toggleDisableSpinBtn(selectedValue) {
      const points = {
        bronze: 10,
        silver: 100,
        gold: 1000
      }

      if(window.points < points[`${selectedValue}`]) {
        this.ui.spinButton.attr('disabled', true)
      } else {
        this.ui.spinButton.attr('disabled', false)
      }
    },

    changeLayer: function (e) {
      const value = $(e.target).data('value');
      const layers = document.querySelectorAll('.layer');
      const positions = ['bottom', 'middle', 'top'];
      const getSrc = (file) => `/assets/common/mypage/img/en_US/promotion/roulette/${file}.png`
  
      layers.forEach((layer, i) => (layer.src = getSrc(`${value}-${positions[i]}`)));
    },

    openModal: function () {
      this.ui.modal.modal({ show: true, backdrop: 'static', keyboard: false });
    },

    closeModal: function () {
      this.ui.modal.modal('hide');
      window.location.reload();
    },

    confirmModal: function () {
      const that = this;
      const reward_history_cd = this.ui.rewardHistoryCd.val();
      const selected_mt4_account_no = this.ui.selectedMt4AccountNo.data('value');

      $.ajax("/rest_promotion/roulette_pay_reward", {
        method: "POST",
        data: {
          'mt4AccountNo': selected_mt4_account_no,
          'rewardHistoryCd': reward_history_cd,
        },
        success: function (data) {
          that.toast(that.ui.toastMessage.html());
          window.location.reload();
        },
        error: function (xhr, textStatus, errorThrown) {
          alert(xhr.responseJSON.message);
        },
      });
    },

    toast: function (msg = '') {
      this.ui.toastText.html(msg);
      this.ui.toast.addClass('show');

      setTimeout(() => {
        this.ui.toast.removeClass('show');
      }, 5000);
    },

    showTooltip: function (e) {
      this.ui.tooltip.addClass('in');
    },

    hideTooltip: function (e) {
      this.ui.tooltip.removeClass('in');

      e.stopPropagation();
    },
  });
});
